enum TripType {
  BUSINESS = "business",
  PERSONAL = "personal",
}

export default TripType;
